import { render, staticRenderFns } from "./AgentPair.vue?vue&type=template&id=7224924c&scoped=true&"
import script from "./AgentPair.vue?vue&type=script&lang=js&"
export * from "./AgentPair.vue?vue&type=script&lang=js&"
import style0 from "./AgentPair.vue?vue&type=style&index=0&id=7224924c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224924c",
  null
  
)

export default component.exports